import React, { useState, useEffect, useRef } from 'react'

import { getUserInfo } from '../../common/cookie';
import SlotList from './SlotList';
import SlotApi from '../../api/SlotApi';
    
export default () => {

    const [counts, setCounts] = useState({
        total: 0,
        progress: 0,
        wait: 0,
        todayExpired: 0
    });

    const refreshCounts = () => {
        SlotApi.getCounts().then(rslt => {
			console.log(rslt);
            if (rslt.data) {
                setCounts(rslt.data);
            } else {
                console.error('카운트 조회 실패:', rslt.message);
                // 에러 시 기본값 유지
            }
        }).catch(error => {
            console.error('카운트 조회 오류:', error);
            // 에러 시 기본값 유지
        });
    }

    useEffect(() => {
        refreshCounts();
    }, []);


    return (
        <div className="vh-content-wrap">
			<div className="content-header">
				<h1>광고관리</h1>
				<h2>광고를 수정하고 관리할 수 있습니다.</h2>
			</div>
			<div className="content">
				<div className="board-area">
					<div className="board-row board-cards">
						<a className="board-card">
							<div className="board-card-title">
								<strong><i class="icon icon-block bg_yellow"></i> 전체</strong>
								<span>보유한 전체 슬롯 개수</span>
							</div>
							<div className="board-card-p">{counts.total}개</div>
						</a>
						<a className="board-card">
							<div className="board-card-title">
								<strong><i class="icon icon-hourglass bg_green"></i> 정상</strong>
								<span>정상 구동중인 슬롯 개수</span>
							</div>
							<div className="board-card-p">{counts.progress}개</div>
						</a>
						<a className="board-card">
							<div className="board-card-title">
								<strong><i class="icon icon-hourglass bg_gray"></i> 대기</strong>
								<span>정보 수집 대기중인 슬롯 개수</span>
							</div>
							<div className="board-card-p">{counts.wait}개</div>
						</a>
						<a className="board-card">
							<div className="board-card-title">
								<strong><i class="icon icon-exmark bg_red"></i> 마감예정</strong>
								<span>오늘 마감예정인 슬롯 개수</span>
							</div>
							<div className="board-card-p">{counts.todayExpired}개</div>
						</a>
					</div>
				</div>

				<SlotList total={counts.total} refreshCounts={refreshCounts} />
			</div>
		</div>
    )
}